import { loadWatiWidget } from '../../shared/src/utils/watiWidget';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';
import { fetchSettingsFromApi, Settings } from '@/contexts/SettingsContext';

const rootElement = document.getElementById('root');

const renderApp = (initialSettings?: Settings | null) => {
  if (!rootElement) return;

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <HelmetProvider>
        <App initialSettings={initialSettings ?? null} />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
      </HelmetProvider>
    </React.StrictMode>
  );
};

(async () => {
  let initialSettings: Settings | null = null;
  try {
    initialSettings = await fetchSettingsFromApi();
  } catch (error) {
    console.error('Preloading settings failed; falling back to in-app fetch', error);
  } finally {
    renderApp(initialSettings);
  }
})();

// Public feature flag; enable after browser/CSP and destination-bot acceptance.
loadWatiWidget(import.meta.env.VITE_WATI_WIDGET_ENABLED === 'true');
